import {Component, Input, OnInit} from '@angular/core';
import {SharedService} from '../../services/shared.service';
import {UserResponseModel} from '../../models/user-response.model';
import {UserRequestModel} from '../../models/user-request.model';
import {Router} from '@angular/router';
import {TokenManager} from '../../services/TokenManager';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']

})
export class HeaderComponent implements OnInit {

  user: UserResponseModel = new UserResponseModel();
  userName: string;
  constructor(private authenticationService: SharedService, private router: Router,  private tokenManager: TokenManager) {
    authenticationService.getLoggedInName.subscribe(name => this.changeName(name));

    this.user = this.tokenManager.retrieveToken();

   // this.user.lastName = 'lmkmkm';


    if (this.user != null) {
      this.router.navigate(['homemenu']);
    } else {
      this.router.navigate(['home']);
    }
  }

  ngOnInit() {
  }

  logut()
  {

    this.tokenManager.removeToken();
    this.user = null;
    this.router.navigate(['home']);
  }


  private changeName(name: UserResponseModel): void {
    this.user = name;

    if (this.user == null) {
      this.router.navigate(['home']);
    }

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts